<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Route') }}</h4>
    </div>
    <div class="modal-body">
      <div class="row">   
        <div class="col-md-12">  
          <div class="form-group">  
            <label for="route">{{ _('Available routes:') }}</label><br />
            <v-select :options="routes" v-model="route" label="name" keys="['id', 'name']" :placeholder="_('Type to search routes')" :create-item="false">
              <template v-slot:no-options="{ searching }">
                <template v-if="searching">
                  {{ _('No results found.') }}
                </template>
                <template v-else>{{ _('Type to search routes') }}</template>
              </template>
            </v-select>
          </div>
          <div class="form-group">
            <label for="routeType">{{ _('Direction') }}</label>
            <select class="form-control" id="routeType" v-model="type">
              <option value="M">{{ _('Outward route') }}</option>
              <option value="P">{{ _('Return route') }}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="selectRoute" :disabled="!isValid"><i class="fa fa-fw fa-save"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      routes: [],
      route: null,
      type: 'M'
    }
  },
  computed: {
    ...mapGetters(['shopId', 'baseDomain', 'apiKey']),
    isValid() {
      return this.route && this.type
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    selectRoute () {
      this.$emit('selectRoute', {
        ...this.route, 
        type: this.type
      })
    },
    async loadRoutes() {
      let response
      try {
        response = await axios.get(this.baseDomain + this.shopId + '/routes.json?apikey=' + this.apiKey)
      } catch(e) {
        return
      }
      this.routes = response.data
    }
  },
  mounted () {
    this.loadRoutes()
  }
}

</script>